export default "__VITE_ASSET__ddfa4193__"